import React from 'react';
import styled from '@emotion/styled';
import { HeaderCellProps, SortDirection } from '../../../types';

type SharedHeaderCellProps<R, SR> = Pick<HeaderCellProps<R, SR>, 'column' | 'sortColumn' | 'sortDirection' | 'onSort'>;

interface Props<R, SR> extends SharedHeaderCellProps<R, SR> {
  children: React.ReactNode;
}

export function SortableHeaderCell<R, SR>({ column, onSort, sortColumn, sortDirection, children }: Props<R, SR>) {
  sortDirection = sortColumn === column.key ? sortDirection : 'NONE';
  let sortText = '';
  if (sortDirection === 'ASC') {
    sortText = '\u2191';
  } else if (sortDirection === 'DESC') {
    sortText = '\u2193';
  }

  function onClick() {
    if (!onSort) return;
    const { sortDescendingFirst } = column;
    let direction: SortDirection;
    switch (sortDirection) {
      case 'ASC':
        direction = sortDescendingFirst ? 'NONE' : 'DESC';
        break;
      case 'DESC':
        direction = sortDescendingFirst ? 'ASC' : 'NONE';
        break;
      default:
        direction = sortDescendingFirst ? 'DESC' : 'ASC';
        break;
    }
    onSort(column.key, direction);
  }

  return (
    <HeaderSortCell className="rdg-header-sort-cell" onClick={onClick}>
      <HeaderSortName className="rdg-header-sort-name">{children}</HeaderSortName>
      <span>{sortText}</span>
    </HeaderSortCell>
  );
}

const HeaderSortCell = styled.span`
  cursor: pointer;
  display: flex;
`;

const HeaderSortName = styled.span`
  flex-grow: 1;
  overflow: hidden;
  overflow: clip;
  text-overflow: ellipsis;
`;
